export const isZero = (value) => {
    return +value === 0;
  };
  